import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { WalletSelectCurrencyModule } from 'src/app/pages/wallet/wallet-select-currency/wallet-select-currency.module';
import { LoadingModule } from '../../directive/loading/loading.module';
import { PipesModule } from '../../pipes/pipes.module';
import { CustomizeFormModule } from '../customize-form/customize-form.module';
import { EmptyModule } from '../empty/empty.module';
import { ScrollbarModule } from '../scrollbar/scrollbar.module';
import { EditCurrencyComponent } from './edit-currency.component';
import { SelectCurrencyComponent } from './select-currency.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    EmptyModule,
    LoadingModule,
    ScrollbarModule,
    CustomizeFormModule,
    MatTabsModule,
    MatSlideToggleModule,
    WalletSelectCurrencyModule,
  ],
  declarations: [SelectCurrencyComponent, EditCurrencyComponent],
})
export class SelectCurrencyModule {}
